import React, { useEffect, useContext } from 'react';
import styled from 'styled-components/macro';
import EditorContext from '../modules/contexts/editor';
import SelectContext from '../modules/contexts/selection';
import LessonPropSheet from '../components/PropertySheets/LessonPropSheet';
import { PropSheet } from '../components/PropertySheets/UI';
import SectionPropSheet from '../components/PropertySheets/SectionPropSheet';
import PagePropSheet from '../components/PropertySheets/PagePropSheet';
import StepPropSheet from '../components/PropertySheets/StepPropSheet';
import ElementPropSheet from '../components/PropertySheets/ElementPropSheet';

const PropertySheetContainer = ({ setRef }) => {
    const editor = useContext(EditorContext);
    const selection = useContext(SelectContext);

    return selection.selectedNode ? (
        <PropSheet ref={setRef}>
            { selection.selectedNode.nodeClass === 'lesson' && <LessonPropSheet node={selection.selectedNode} /> }
            { selection.selectedNode.nodeClass === 'section' && <SectionPropSheet node={selection.selectedNode} /> }
            { selection.selectedNode.nodeClass === 'page' && <PagePropSheet node={selection.selectedNode} /> }
            { selection.selectedNode.nodeClass === 'step' && <StepPropSheet node={selection.selectedNode} /> }
            { selection.selectedNode.nodeClass === 'element' && <ElementPropSheet node={selection.selectedNode} /> }
        </PropSheet>
    ) : null;
};

export default PropertySheetContainer;